import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "shop-form__block"
}
const _hoisted_2 = { class: "shop-form__head" }
const _hoisted_3 = { class: "shop-form__table" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 1,
  class: "shop-form__block"
}
const _hoisted_6 = { class: "shop-form__head" }
const _hoisted_7 = { class: "shop-form__table" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 2,
  class: "quantity"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "shop-form__title" }, "Количество", -1)
const _hoisted_11 = ["onClick"]

import { computed, watch } from "vue";
import { useStore } from "vuex";
import { TypeLoyalityKinds, TypeLoyaliyMainName } from "@/types";
import {TypeAbonementObj, TypeCertificateObj} from '@/types/typesOfApi'
import {
  IloyalityShopData,
  TypeReceiver,
  TypeSortedLoyalityByName,
  IbyCertificate,
  IbyAbonement,
} from "@/types/typesOfState";
import { Store } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'stepSetAdditionalParams',
  setup(__props) {

const store = useStore();

const loyalityShopData = computed<IloyalityShopData>(
  () => store.state.loyalityShopData
);
const currentLoyalityKind = computed<TypeLoyalityKinds>(
  () => store.state.currentLoyalityKind
);

const sortedLoyalityByName = computed<TypeSortedLoyalityByName>(
  () => store.state.sortedLoyalityByName
);

const currentCertificateData = computed<IbyCertificate>(
  () => store.state.loyalityShopData.byCertificate
);
const currentSortedItemByCertificate = computed<TypeLoyaliyMainName>(
  () =>
    store.state.sortedLoyalityByName.certificates[
      currentCertificateData.value.name || ""
    ]
);
const currentAbonementData = computed<IbyAbonement>(
  () => store.state.loyalityShopData.byAbonement
);
const currentSortedItemByAbonement = computed<TypeLoyaliyMainName>(
  () =>
    store.state.sortedLoyalityByName.abonements[
      currentAbonementData.value.name || ""
    ]
);

function setLoyality(loyalityName: string): void {
  if (currentLoyalityKind.value === "certificate") {
    store.state.loyalityShopData.byCertificate.name = loyalityName;
  } else {
    store.state.loyalityShopData.byAbonement.name = loyalityName;
  }
}

watch(
  currentAbonementData,
  (value: IbyAbonement) => {
    console.log(value);

    if (
      value.seanceLength &&
      value.seats
    ) {
      const currentAbonements:TypeAbonementObj[]= currentSortedItemByAbonement.value.list;

      const currentAbonement:TypeAbonementObj | undefined = currentAbonements.find((i: TypeAbonementObj) => {
        const currentRegExpText = `${value.seanceLength}\\s*(минут)?`;
        const currentRegExp = new RegExp(currentRegExpText, "i");
        return (
          i.united_balance_services_count === value.seats &&
          currentRegExp.test(i.title)
        );
      });

      const currentAbonementId = currentAbonement?.id;

      store.state.loyalityShopData.buyLoyalityType = currentAbonementId;
    }
  },
  { deep: true }
);
watch(
  currentCertificateData,
  (value: IbyCertificate) => {
    console.log(value);

    if (value.seanceLength) {
      const currentCertificates:TypeCertificateObj[] = currentSortedItemByCertificate.value.list;

      const currentCertificate: TypeCertificateObj | undefined = currentCertificates.find((i: TypeCertificateObj) => {
        const currentRegExpText = `${value.seanceLength}\\s*(минут)?`;
        const currentRegExp = new RegExp(currentRegExpText, "i");
        return currentRegExp.test(i.title);
      });

      const currentcertificateId = currentCertificate?.id;

      store.state.loyalityShopData.buyLoyalityType = currentcertificateId;
    }
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (currentLoyalityKind.value === 'certificate')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(currentSortedItemByCertificate.value.title === "Номинал"
          ? ""
          : currentSortedItemByCertificate.value.title), 1),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentSortedItemByCertificate.value.minutesArray, (time) => {
              return (_openBlock(), _createElementBlock("span", {
                class: _normalizeClass(["button grey", {
          active: currentCertificateData.value.seanceLength === time,
        }]),
                onClick: ($event: any) => (currentCertificateData.value.seanceLength = time),
                key: time
              }, _toDisplayString(time), 11, _hoisted_4))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (currentLoyalityKind.value === 'abonement')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(currentSortedItemByAbonement.value.title), 1),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentSortedItemByAbonement.value.minutesArray, (time) => {
              return (_openBlock(), _createElementBlock("span", {
                class: _normalizeClass(["button grey", {
          active: currentAbonementData.value.seanceLength === time,
        }]),
                onClick: ($event: any) => (currentAbonementData.value.seanceLength = time),
                key: time
              }, _toDisplayString(time), 11, _hoisted_8))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (currentLoyalityKind.value === 'abonement')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentSortedItemByAbonement.value.balancesArray, (seat) => {
            return (_openBlock(), _createElementBlock("span", {
              class: _normalizeClass(["button grey", {
        active: currentAbonementData.value.seats === seat,
      }]),
              onClick: ($event: any) => (currentAbonementData.value.seats = seat),
              key: seat
            }, _toDisplayString(seat), 11, _hoisted_11))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})